export const bpieAdminSections = {
    Import: "Import MSID",
    Create: "Create SBPIES",
    Region: "Manage Regions",
    ManageFin: "Manage FIN Facilitators"
};